import { TransactionStatus } from '../../entities/TransactionStatus/TransactionStatus';
import { TransactionStatusResponseDTO } from '../../entities/TransactionStatus/TransactionStatusResponseDTO';

const TransactionStatusResponseDTOtoTransactionStatusAdapter = (
  response: TransactionStatusResponseDTO,
): TransactionStatus[] => {
  if (!response.body) {
    throw Error();
  }
  return response.body.statuses.map(({ id, description }) => new TransactionStatus(id, description));
};

export { TransactionStatusResponseDTOtoTransactionStatusAdapter };
